import environments from "../../../../environments";
import { AraucariaConclusion } from "./providers/araucaria";
import { IpirangaConclusion } from "./providers/ipiranga";
import { JczConclusion } from "./providers/jacarezinho";
import { StandardConclusion } from "./providers/standard";

export const Conclusion: React.FC = () => {
    switch (environments.client.name) {
        case "jcz":
            return <JczConclusion />;
        case "ipiranga":
            return <IpirangaConclusion />;
        case "araucaria":
            return <AraucariaConclusion />;
        default:
            return <StandardConclusion />;
    }
};
